export const AxiosConstant = {
  RETRY_TIMEOUT: 30000,
};
